import React, { useEffect, useState } from 'react';
import {
  Button,
  createStyles,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  makeStyles,
  Radio,
  RadioGroup,
  TextField,
  Theme,
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { Autocomplete } from '@material-ui/lab';

import { useMutation, useQuery } from 'react-query';
import MotorPlate from './motorPlate';
import Plate from './plate';
import { getTPLs } from '../requests/getTPLs';
import getVehicleByPlateNum from '../requests/getVehicleByPlateNum';
import { createEntrance } from '../requests/createVehicleEntrance';
import { addNewDriver } from '../requests/addNewDriver';
import { useHistory } from 'react-router-dom';
import handleNotfication from '../../../utils/handleNotfication';
import getDriverByOwnerId from '../requests/getDriverByOwnerId';
import { Entrance } from 'client-sdk/src/entrances/interface';
import { parseInt } from 'lodash';
import handleError from '../../../utils/handleError';
import PartnersRepository from 'client-sdk/src/Repository/partners-repository'

//Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inlineRadioGroups: {
      display: 'flex',
      flexDirection: 'row',
    },
    drawDown: {
      padding: '20px 12px',
      backgroundColor: '#fff',
      marginBottom: '50px',
    },
    circularIcon: {
      color: '#2f4858',
      paddingLeft: '8px',
      position: 'fixed',
      bottom: 0,
      opacity: '90%',
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    errorText: {
      color: '#F30000',
      fontSize: '11px',
    },
    errorPlate: {
      marginTop: '20px',
      marginLeft: '15px',
    },
    topText: {
      color: '#2f4858',
      fontSize: '16px',
    },
    appBar: {
      padding: '16px',
      backgroundColor: '#ffffff',
      zIndex: theme.zIndex.drawer + 1,
      boxShadow: 'none',
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    bottom: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      height: '80px',
      backgroundColor: '#fff',
      borderTop: '0.5px solid #828282',
      padding: '16px',
      zIndex: 12,
    },
  })
);

const carTypes = [
  'پراید',
  'پژو ۴۰۵',
  'پژو ۲۰۶',
  'آریسان',
  'پیکان وانت',
  'پیکان',
  'ام وی ام',
  'پرشیا',
  'تندر ۹۰',
  'تیبا',
  'دنا',
  'ریو',
  'سمند',
  'نیسان',
  'ون دلیکا',
];

export const AddDriverParcelForm = (props: {}) => {
  const classes = useStyles();
  const { register, handleSubmit, watch, getValues, errors, setValue } = useForm({
    defaultValues: {

    }
  });

  const [entityType, setEntityType] = useState('order');
  const [vehicleType, setVehicleType] = useState('CAR');
  const [platePattern, setPlatePattern] = useState<any>('');
  const [partner, setPartner] = useState<any>('');
  const [partners, setPartners] = useState<any>([]);
  const [carType, setCarType] = useState<any>('نامشخص');
  const [formType, setFormType] = useState<'create' | 'fill'>('create');
  const [isColorSpecified, toggleColorSpecified] = useState<boolean>(false);
  const [driverName, setDriverName] = useState<string | undefined>(undefined);
  const [driverPhoneNum, setDriverPhoneNum] = useState<string | undefined>(
    undefined
  );
  const [hasDriverName, setHasDriverName] = useState<boolean | undefined>(
    undefined
  );
  const [hasPhoneNumber, setHasPhoneNumber] = useState<boolean | undefined>(
    undefined
  );

  const token = localStorage.getItem('token');
  const history = useHistory();

  const driverMutation = useMutation(addNewDriver);

  const submitEntrance = useMutation(createEntrance);

  const getPartners = async () => {
    try {
      const { response } = await PartnersRepository.getPartners({ payload: { size: 1000 } })
      setPartners(response.data)
    } catch (err) {
      handleError(err)
    }
  }

  useEffect(() => {
    getPartners()
  }, [])

  useEffect(() => {
    setPlatePattern(/^\d{2}[\u0600-\u06FF]\d{3}\-\d{2}$/g);
    if (vehicleType === 'MOTORCYCLE') {
      setPlatePattern(/^\d{8}$/g);
    }
  }, [vehicleType]);

  useEffect(() => {
    if (vehicleType !== 'MOTORCYCLE' && getValues().plateNumber.length === 9) {
      getVehicle(getValues().plateNumber);
    }
    if (vehicleType === 'MOTORCYCLE' && getValues().plateNumber.length === 8) {
      getVehicle(getValues().plateNumber);
      setCarType('موتورسیکلت');
    }
  }, [watch(['plateNumber'])]);

  // get vehicle by plateNumber
  const getVehicle = (plateNum: any) => {
    const response = getVehicleByPlateNum(plateNum);
    let registeredVehicleData;
    let driverInformation;
    let Courier;
    response
      .then(recoveredData => {
        registeredVehicleData = recoveredData.data;
        if (registeredVehicleData.length > 0) {
          //Request with ownerId to get driver info
          const driverResponse = getDriverByOwnerId(
            registeredVehicleData[0].ownerId
          );
          driverResponse.then((driverData: any) => {
            driverInformation = driverData.data;
            setValue('phoneNumber', parseInt(driverInformation.phoneNumber));
            setDriverPhoneNum(driverInformation.phoneNumber);
            setValue('driverName', driverInformation.name);
            setDriverName(driverInformation.name);
          });

          setValue('carColor', registeredVehicleData[0].color);
          setFormType('fill');
          setVehicleType(registeredVehicleData[0].klass);
          if (vehicleType === 'MOTORCYCLE') {
            setCarType('موتورسیکلت');
            setValue('carColor', 'موتورسیکلت');
          } else {
            setCarType(registeredVehicleData[0].type);
          }
          setValue('carType', registeredVehicleData[0].type);
        } else {
          setFormType('create');
        }
      })
      .catch(err => {
        console.log(err);
      });
    // if(response.data.length == 0){
    //     setFormType("create")
    //   }
    // else if (response.data.length > 0){
    //     setFormType("fill");
    //   }
  };

  const onSubmit = (data: any) => {
    if (formType === 'create') {
      const payload = {
        ...(vehicleType === 'MOTORCYCLE' && { color: 'موتورسیکت' }),
        color: data.carColor ? data.carColor : 'نامشخص',
        parkingNumber: data.parkingNumber ? data.parkingNumber : '-1',
        name: data.driverName ? data.driverName : 'ناشناس',
        plateNumber: data.plateNumber,
        vehicleClass: vehicleType ? vehicleType : 'موتورسیکلت',
        vehicleType: carType,
        fleetId: 28,
        phoneNumber: data.phoneNumber,
        type: "PARCEL",
        partnerId: partner,
      };

      driverMutation.mutate(payload as Entrance, {
        onSuccess: (mydata, variables) => {
          //othertoast
          handleNotfication('راننده با موفقیت افزوده شد', 'success');
          history.push('/security/active-drivers');
        },

        onError: (error, variables) => {
          //error toast
          handleNotfication('خطا در افزودن راننده', 'error');
        },
      });
    } //Added mutation
    else {
      let fetchedPlateVehicleId;
      getVehicleByPlateNum(data.plateNumber).then(fetchedData => {
        fetchedPlateVehicleId = fetchedData.data[0].id;
        const payload = {
          parkingNumber: data.parkingNumber,
          vehicleId: fetchedPlateVehicleId,
          partnerId: partner,
          parcelIds: [data.parcel],
          description: data.description,
          type: "PARCEL"
        };
        submitEntrance.mutate(payload as Entrance, {
          onSuccess: (mydata, variables) => {
            handleNotfication('ورود با موفقیت ثبت شد', 'success');
            history.push('/security/active-drivers');
          },
          onError: (error, variables) => {
            handleNotfication('خطا در ثبت ورود', 'error');
          },
        });
      });
    }
  };

  const handleVehicleRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setVehicleType((event.target as HTMLInputElement).value);
  };

  const jumpFocusOn = (itemID: string): void => {
    const focusableElem: HTMLElement | null = document.getElementById(itemID);
    focusableElem?.focus();
  };

  const {
    isLoading,
    error,
    data: TPLs,
  } = useQuery('TPLs', getTPLs, {
    staleTime: 100 * 60 * 1000, //100 minutes fresh data
    cacheTime: 300 * 60 * 1000, //hold cached data for 300 minutes
  });

  const values = getValues();

  return (
    <div className={classes.drawDown}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={1}>
          <Grid item>
            <FormLabel component="legend">وسیله نقلیه</FormLabel>
            <RadioGroup
              row
              name="vehicleType"
              value={vehicleType}
              onChange={handleVehicleRadioChange}
              defaultValue="CAR"
            >
              <FormControlLabel
                value="CAR"
                control={<Radio />}
                label="سواری"
                defaultChecked={true}
              />
              {/* <FormControlLabel
                value="PICKUPS"
                control={<Radio />}
                label="وانت"
              /> */}

              <FormControlLabel
                value="MOTORCYCLE"
                control={<Radio />}
                label="موتور سیکلت"
              />
            </RadioGroup>
          </Grid>

          <Grid item xs={12}>
            {vehicleType === 'MOTORCYCLE' ? (
              <MotorPlate
                getNumber={number => setValue('plateNumber', number)}
              />
            ) : (
              <Plate getNumber={number => setValue('plateNumber', number)} />
            )}
            <TextField
              fullWidth
              style={{ display: 'none' }}
              id="plateNumber"
              name="plateNumber"
              label="پلاک خودرو"
              className={classes.textInput}
              inputRef={register({
                required: true,
                pattern: platePattern,
                minLength: vehicleType === 'MOTORCYCLE' ? 8 : 9,
                maxLength: vehicleType === 'MOTORCYCLE' ? 8 : 9,
              })}
              error={errors.plateNumber && true}
            />
            <div className={classes.errorPlate}>
              {values.plateNumber &&
                !values.plateNumber.match(platePattern) && (
                  <p className={classes.errorText}>
                    {'فرمت فیلد پلاک خودرو صحیح نیست'}
                  </p>
                )}
            </div>
            <FormHelperText error focused>
              {errors.plateNumber &&
                errors.plateNumber.type === 'required' &&
                'پلاک الزامی میباشد'}
            </FormHelperText>
          </Grid>

          <Grid item xs={12}>
            <TextField
              inputRef={register({ required: false })}
              fullWidth
              name="phoneNumber"
              id="phone-number"
              label="شماره موبایل"
              variant="outlined"
              type="number"
              InputLabelProps={{
                shrink: !!driverPhoneNum || hasPhoneNumber,
              }}
              onChange={(event: any, newValue: any | null) => {
                if (newValue) {
                  setDriverPhoneNum(parseInt(newValue.id));
                } else {
                  setDriverPhoneNum(undefined);
                }
                if (event.target.value !== '') {
                  setHasPhoneNumber(true);
                }
                if (event.target.value === undefined) {
                  setHasPhoneNumber(false);
                }
              }}
            />
            <FormHelperText error focused>
              {errors.phoneNumber && 'شماره موبایل الزامی میباشد'}
            </FormHelperText>
          </Grid>

          <Grid item xs={12}>
            <Autocomplete
              id="partner"
              options={partners?.length > 0 ? partners : []}
              getOptionLabel={option => option.name}
              onChange={(event: any, newValue: any | null) => {
                if (newValue) {
                  setPartner(newValue.id);
                } else {
                  setPartner('');
                }
              }}
              onClose={() => jumpFocusOn('carType')}
              renderInput={params => (
                <TextField
                  inputRef={register({ required: true })}
                  name="partner"
                  {...params}
                  label="شرکت"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: !!partner,
                  }}
                />
              )}
            />
            <FormHelperText error focused>
              {errors.courier && 'کوریر الزامی میباشد'}
            </FormHelperText>
          </Grid>

          {vehicleType !== 'MOTORCYCLE' && (
            <>
              <Grid item xs={6}>
                <Autocomplete
                  id="carType"
                  freeSolo
                  options={carTypes}
                  getOptionLabel={option => option}
                  onChange={(event: any, newValue: any | null) => {
                    setCarType(newValue);
                  }}
                  onClose={() => jumpFocusOn('carColor')}
                  value={carType}
                  renderInput={params => (
                    <TextField
                      inputRef={register({ required: false })}
                      name="carType"
                      {...params}
                      label="مدل خودرو"
                      variant="outlined"
                    />
                  )}
                />
                <FormHelperText error focused>
                  {errors.carType && 'مدل خودرو الزامی میباشد'}
                </FormHelperText>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  id="carColor"
                  label="رنگ خودرو"
                  variant="outlined"
                  name="carColor"
                  inputRef={register({ required: false })}
                  onChange={(event: any, typedInValue: any | null) => {
                    if (typedInValue != '') {
                      toggleColorSpecified(true);
                    }
                    if (typedInValue == '') {
                      toggleColorSpecified(false);
                    }
                  }}
                  InputLabelProps={{
                    shrink: !!values.carColor || isColorSpecified,
                  }}
                />
                <FormHelperText error focused>
                  {errors.carColor && 'رنگ خودرو الزامی میباشد'}
                </FormHelperText>
              </Grid>
            </>
          )}

          <Grid item xs={12}>
            <TextField
              fullWidth
              id="driver-name"
              name="driverName"
              label="نام راننده"
              variant="outlined"
              inputRef={register({ required: false })}
              InputLabelProps={{
                shrink: !!driverName || hasDriverName,
              }}
              onChange={(event: any, newValue: any | null) => {
                if (newValue) {
                  setDriverName(newValue.id);
                } else {
                  setDriverName('');
                }
                if (event.target.value !== '') {
                  setHasDriverName(true);
                }
                if (event.target.value === '') {
                  setHasDriverName(false);
                }
              }}
            />
            <FormHelperText error focused>
              {errors.driverName && 'نام راننده الزامی میباشد'}
            </FormHelperText>
          </Grid>

          {/* {vehicleType !== 'MOTORCYCLE' && ( */}
          {/* )} */}

          <Grid item xs={12}>
            <TextField
              inputRef={register({ required: false })}
              fullWidth
              type="number"
              name="parkingNumber"
              id="parking-number"
              label="شماره پارکینگ"
              variant="outlined"
            />
            <FormHelperText error focused>
              {errors.parkingNumber && 'شماره پارکینگ الزامی میباشد'}
            </FormHelperText>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id="parcel"
              name="parcel"
              label="شناسه محموله"
              variant="outlined"
              inputRef={register({ required: false })}
            />
            <FormHelperText error focused>
              {errors.description && 'محموله الزامی میباشد'}
            </FormHelperText>
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              id="description"
              name="description"
              label="توضیحات"
              variant="outlined"
              inputRef={register({ required: false })}
            />
            <FormHelperText error focused>
              {errors.description && 'نام راننده الزامی میباشد'}
            </FormHelperText>
          </Grid>
        </Grid>
        <div className={classes.bottom}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            size="large"
          >
            {formType === 'create' ? 'ذخیره راننده جدید' : 'ثبت اطلاعات'}
          </Button>
        </div>
      </form>
    </div>
  );
};
